<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar','Veiculos')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormVeiculo.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Novo Veiculo
      </v-btn>
      <DialogFormVeiculo @created="create($event)" ref="dialogFormVeiculo" />
      <v-form ref="form">
        <v-row align="center">
          <v-col cols="12" sm="12" md="2">
            <SelectFabricante :multiple="false" @onChanged="fabricante = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <SelectAtivo @onChanged="itemsSelectAtivo = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="1">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Veiculo from "@/services/veiculo";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Filtro",

  components: {
    SelectFabricante: () => import("@/components/select/SelectFabricante"),
    DialogFormVeiculo: () => import("./DialogFormVeiculo"),
    SelectAtivo: () => import("@/components/select/SelectAtivo")
  },

  data() {
    return {
      fabricante: null,
      itemsSelectAtivo: "",
      veiculoService: new Veiculo()
    };
  },

  computed: {
    ...mapGetters("veiculos", ["getVeiculos"])
  },

  methods: {
    ...mapActions("veiculos", ["setVeiculos"]),

    async buscar() {
      if (this.$refs.form.validate()) {
        try {
          const veiculos = await this.veiculoService.getByFabricanteAndAtivo(
            this.fabricante,
            this.itemsSelectAtivo == "Sim" ? true : false
          );
          this.setVeiculos(veiculos);
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao efetuar a busca");
          return Promise.reject(error);
        }
      }
    },

    create(veiculo) {
      if (this.getVeiculos === null) {
        this.setVeiculos([
          {
            id: veiculo.id,
            anoModelo: veiculo.anoModelo,
            dataCriacao: veiculo.dataCriacao,
            descricao: veiculo.descricao,
            empresas: veiculo.empresas,
            fabricante: veiculo.fabricante,
            foto: veiculo.foto,
            modeloIhs: veiculo.modeloIhs,
            ordem: veiculo.ordem,
            seguimento: veiculo.seguimento,
            precoRegioes: {
              Norte: veiculo.precoRegioes["Norte"],
              "Centro-Oeste": veiculo.precoRegioes["Centro-Oeste"]
            }
          }
        ]);
      } else {
        this.setVeiculos(
          this.getVeiculos.concat(
            ...[
              {
                id: veiculo.id,
                anoModelo: veiculo.anoModelo,
                dataCriacao: veiculo.dataCriacao,
                descricao: veiculo.descricao,
                empresas: veiculo.empresas,
                fabricante: veiculo.fabricante,
                foto: veiculo.foto,
                modeloIhs: veiculo.modeloIhs,
                ordem: veiculo.ordem,
                seguimento: veiculo.seguimento,
                precoRegioes: {
                  Norte: veiculo.precoRegioes["Norte"],
                  "Centro-Oeste": veiculo.precoRegioes["Centro-Oeste"]
                }
              }
            ]
          )
        );
      }
    }
  }
};
</script>
